import { FilterFilled } from '@ant-design/icons';
import { Input, Checkbox, Button, DatePicker } from 'antd';
import moment from 'moment';
import React,{ useState } from 'react';


/**
 * This file is used for all common function and component used by Antd table search and sort filters. which we can reuse at different places
 *
 */
// creatd function to validate the if it correct field and correct component to reuse the logic
function isValidFieldAndComponent(fieldName, component) {
  return (
    (fieldName === 'assetGroupName' && component === 'Asset_Selected') ||
    (fieldName === 'checkListSectionName' &&
      component === 'Asset_IPSLoc_selected')
  );
}

function composeFilters(fieldName, array, component) {
  let filters = [
    ...new Set(
      array?.map((eachElement) => {
        // condition used in Assets Task Tab and AssetTask Selected compoenent selected file adn
        if (
          isValidFieldAndComponent(fieldName, component) &&
          eachElement.deleteFlag &&
          (eachElement.deleteFlag === 'P' || eachElement.deleteFlag === 'B')
        ) {
          return 'VERIFY IPS DATA';
        } else if (fieldName === 'resolutionDate' && component === 'PreEFormExceptionGrid') {
          return moment(eachElement[fieldName]).format('MM/DD/YYYY') || '[BLANK]'
        } else {
          return eachElement[fieldName] || '[BLANK]';
        }
      })
    ),
  ];

  let filtersSort = filters.map((distinctFilters) => ({
    text: distinctFilters,
    value: distinctFilters,
  }));

  filtersSort.sort((a, b) => {
    
    a = a.text || '';
    b = b.text || '';
    
    if (typeof a === 'number' || typeof b === 'number') {
     
      return a - b;
    }
    return a.toString().toLowerCase().localeCompare(b.toString().toLowerCase());
  });

  return filtersSort;
}
/* This function is used for serach and dropdown function it uses the lable and value as object so whenever you are using SearchAndDropDownComponent please use this function OnFilter */
function searchAndDropDownFilters(fieldName, array) {
  let filters = [
    ...new Set(array.map((eachElement) => eachElement[fieldName] || '[BLANK]')),
  ];
  let filtersSort = filters.map((distinctFilters) => ({
    label: distinctFilters,
    value: distinctFilters,
  }));
  filtersSort.sort((a, b) => {
    
    a = a.label || '';
    b = b.label || '';
    if (typeof a === 'number' || typeof b === 'number') {
      return a - b;
    }
    return a.toLowerCase().localeCompare(b.toLowerCase());
  });

  return filtersSort;
}
function searchAndDropDownOnFilters(value, record, fieldName) {
  if (value === '[BLANK]') {
    
    return !record[fieldName];

    // Added check for the Asset Task filtering
  }
  return value === record[fieldName];
}

const SearchAndDropdownComponent = () => {
  let [typedValue, setTypedValue] = useState('');

  return {
    filterDropdown: ({
      filters,
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => {
      
      let searchedFilters = filters?.filter((eachItem) =>
        String(eachItem.value).toLowerCase().includes(typedValue.toLowerCase())
      );
      return (
        <div className='custom-filter-dropdown' style={{ padding: '10px' }}>
          <Input
            autoFocus
            placeholder='Search'
            value={typedValue}
            onChange={(e) => {
              e.preventDefault();

              setTypedValue(e.target.value);
            }}
            onPressEnter={() => {
              confirm();
            }}
            // onBlur={() => {
            //   confirm();
            // }}
          />

          <div className='name-checkbox'>
            <Checkbox.Group
              options={searchedFilters}
              value={selectedKeys}
              onChange={(value) => {
                setSelectedKeys(
                  // value && value.length > 0 ?
                  selectedKeys.length > 0
                    ? typedValue ===''
                      ? [...value]
                      : [
                          ...new Set([
                            ...value,
                            ...selectedKeys.filter(
                              (s) =>
                                !searchedFilters.map((f) => f.label).includes(s)
                            ),
                          ]),
                        ]
                    : [...value]
                  //: []
                );
              }}
            />
          </div>

          <div>
            <Button
              size='small'
              type='primary'
              disabled={selectedKeys.length === 0}
              style={{ width: 90, marginRight: 8 }}
              onClick={() => {
                setTypedValue('');
                confirm();
              }}
            >
              Filter
            </Button>

            <Button
              size='small'
              onClick={() => {
                setTypedValue('');
                
                clearFilters();
                confirm()
              }}
              style={{ width: 90 }}
            >
              Reset
            </Button>
          </div>
        </div>
      );
    },
    filterIcon: () => {
      return <FilterFilled />;
    },
  };
};

const DatePickerAndDropdownComponent = () => ({
  filterDropdown: ({
    filters,
    setSelectedKeys,
    selectedKeys,
    confirm,
    clearFilters,
  }) => {
    return (
      <div className='custom-filter-dropdown' style={{ padding: '8px' }}>
        <DatePicker
          style={{ height: 40 }}
          value={
            selectedKeys[0] && !Array.isArray(selectedKeys[0])
              ? moment(selectedKeys[0])
              : null
          }
          onChange={(date) => {
            setSelectedKeys(date ? [moment(date).format('MMMM DD, YYYY')] : []);
          }}
          format={'MMMM DD, YYYY'}
        />

        <div className='name-checkbox'>
          <Checkbox.Group
            options={filters}
            value={selectedKeys[0]}
            onChange={(value) => {
              setSelectedKeys(value && value.length > 0 ? [value] : []);
            }}
          />
        </div>

        <div>
          <Button
            size='small'
            type='primary'
            disabled={selectedKeys.length === 0}
            style={{ width: 90, marginRight: 8 }}
            onClick={() => {
              confirm();
            }}
          >
            Filter
          </Button>

          <Button
            size='small'
            onClick={() => {
              clearFilters();
            }}
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </div>
      </div>
    );
  },
  filterIcon: () => {
    return <FilterFilled />;
  },
});

let getStationRoleName = (array) => {
  let listOfRole = new Set();

  array?.map((task) => {
    task.userRoles.map((everyRoleArray) =>
      listOfRole.add(
        JSON.stringify({
          text: everyRoleArray.roleName,
          value: everyRoleArray.roleId,
        })
      )
    );
  });

  let listOfRoleArray = [...listOfRole];

  return listOfRoleArray.map((everyItem) => {
    return JSON.parse(everyItem);
  });
};

/**
 * Common OnFilter Function with comparing normal value with record this Function Can be used for onFilter method
 */


const commonFilter = (value, record, fieldName, component) => {
  if (value === '[BLANK]') {
    
    return !record[fieldName];

    // Added check for the Asset Task filtering
  } else if (value === 'VERIFY IPS DATA') {
    return (
      record.deleteFlag &&
      (record.deleteFlag === 'P' || record.deleteFlag === 'B')
    );
    // Added check for the Asset Task filtering
  } else if (
    isValidFieldAndComponent(fieldName, component) &&
    record.deleteFlag &&
    (record.deleteFlag === 'P' || record.deleteFlag === 'B')
  ) {
    return (
      record.deleteFlag !== 'P' &&
      record.deleteFlag !== 'B' &&
      record[fieldName] === value
    );
  }else if (fieldName === 'resolutionDate' && component === 'PreEFormExceptionGrid') {
    return moment(record[fieldName]).format('MM/DD/YYYY') === value
  }

  return record[fieldName] === value;
};

/**
 * Common Sorter function to use for Antd Sort Function when sorting by field Name
 */

const commonSorter = (a, b, fieldName, component) => {
  // Added check for asset Tasks filter
  if (
    isValidFieldAndComponent(fieldName, component) &&
    a.deleteFlag &&
    (a.deleteFlag === 'P' || a.deleteFlag === 'B')
  ) {
    a = 'VERIFY IPS DATA';
    b = b[fieldName] || '';
  } else if (
    ((fieldName === 'assetGroupName' && component === 'Asset_Selected') ||
      (fieldName === 'checkListSectionName' &&
        component === 'Asset_IPSLoc_selected')) &&
    b.deleteFlag &&
    (b.deleteFlag === 'P' || b.deleteFlag === 'B')
  ) {
    a = a[fieldName] || '';
    b = 'VERIFY IPS DATA';
  } else {
    a = a[fieldName] || '';
    b = b[fieldName] || '';
  }
  if (typeof a === 'number' || typeof b === 'number') {
    return a - b;
  }
  return a.toString().toLowerCase().localeCompare(b.toString().toLowerCase());
};

const commonDateSorter = (a, b, fieldName) => {
  a = a[fieldName] || moment('1900-01-01');
  b = b[fieldName] || moment('1900-01-01');
  if (moment(a).isValid() && moment(b).isValid())
    return moment(a).unix() - moment(b).unix();
  else if (moment(a).isValid()) return moment(a).unix();
  else if (moment(b).isValid()) return moment(b).unix();
  else return moment(a).unix() - moment(b).unix();
};
export {
  composeFilters,
  SearchAndDropdownComponent,
  DatePickerAndDropdownComponent,
  getStationRoleName,
  commonFilter,
  commonSorter,
  commonDateSorter,
  searchAndDropDownFilters,
  searchAndDropDownOnFilters,
};
